module.exports = __webpack_public_path__ + "media/images/athletes/1451-670197d1e337281e89e4cafb4b70a977.png";